import React, { memo } from 'react'

import { string, shape, func, bool } from 'prop-types'

import ImageUploader from './Components/ImageUploader/ImageUploader'
import MultiViewUploader from './Components/MultiViewUploader/MultiViewUploader'
import Tabs from './Components/Tabs/Tabs'
import TextInstructions from './Components/TextInstructions/TextInstructions'

function ActionSelector({ id, tabs, sliceName, storeSchemaKey }) {
  const isImageTo3D = tabs.image.isActive
  const isMultiViewTo3D = !!tabs.multiView?.isActive
  const isTextTo3D = tabs.text.isActive

  return (
    <div className="action-selector">
      <Tabs tabs={tabs} />
      {isImageTo3D && (
        <ImageUploader
          sliceName={sliceName}
          storeSchemaKey={storeSchemaKey}
          setInputImage={tabs.image.setInputImage}
        />
        )}
      {isMultiViewTo3D && (
        <MultiViewUploader
          sliceName={sliceName}
          storeSchemaKey={storeSchemaKey}
          setInputViewImage={tabs.multiView.setInputViewImage}
        />
      )}
      {isTextTo3D && (
        <TextInstructions
          id={id}
          sliceName={sliceName}
          storeSchemaKey={storeSchemaKey}
          placeholder={tabs.text.placeholder}
          setPrompt={tabs.text.setPrompt}
        />
      )}
    </div>
  )
}

ActionSelector.propTypes = {
  id: string.isRequired,
  sliceName: string.isRequired,
  storeSchemaKey: string.isRequired,
  tabs: shape({
    image: shape({
      id: string.isRequired,
      onClick: func.isRequired,
      isActive: bool.isRequired,
      setInputImage: func.isRequired,
    }).isRequired,
    multiView: shape({
      id: string.isRequired,
      onClick: func.isRequired,
      isActive: bool.isRequired,
      setInputViewImage: func.isRequired,
    }),
    text: shape({
      id: string.isRequired,
      onClick: func.isRequired,
      isActive: bool.isRequired,
      placeholder: string,
      setPrompt: func.isRequired,
    }).isRequired,
  }).isRequired,
}

export default memo(ActionSelector)
